import { RootState } from "@/shared/types";

import { IAsideSettings } from "./types/interfaces";

export const selectSettings = (state: RootState): IAsideSettings =>
  state.aside.settings;

export const selectIsLoading = (state: RootState): boolean =>
  state.aside.isLoading;
